import _ from 'lodash';

export default {
  name: 'MRadio',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    grid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return this.options.map((option) => {
        if (option instanceof Object) {
          return option;
        }
        return {
          value: () => option,
        };
      });
    },
    idAttr() {
      return option => _.kebabCase(`${this.id.toLowerCase()}-${option.value()}`);
    },
  },
};
